
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  pageSize: 10,

  // // Demo-tras.getapcs
  //   transactionApiUrl: 'https://demo-tras.getapcs.com:8039/api',
  //   master1ApiUrl: 'https://demo-tras.getapcs.com:8040/api',
  //   productionApiUrl: 'https://demo-tras.getapcs.com:8041/api',
  //   purchaseApiUrl: 'https://demo-tras.getapcs.com:8042/api',
  //   warehouseServiceApiUrl: 'https://demo-tras.getapcs.com:8044/api',
  //   saleServiceApiUrl: 'https://demo-tras.getapcs.com:8043/api',
  // masterService: '/get_all_details',

  // apiUrl: 'http://192.168.11.100:4520/api',
  // apiUrl: 'http://216.48.179.121:8007',
  // apiUrl: 'https://bi.wyzmindz.com:8007',


  // demo api
  // apiUrl: 'https://demo-sb-api.wyzmindz.com',

  // trasccon api 
  apiUrl: 'https://trasccon-sbapi.wyzmindz.com',  


  // auckam Instance
  //  apiUrl: 'https://api-auckam.sourcebuddy.in',

  // ngp Instance

  // apiUrl: 'https://ngp-api.sourcebuddy.in',

  // varsity Instance 
  // apiUrl:  'https://api-varsity.sourcebuddy.in',
  //sreevidya
  // apiUrl:  'https://sreevidya-api.sourcebuddy.in',
  ///ortecs
  //  apiUrl:  'https://ortecs-api.sourcebuddy.in',

  ///infiact
  //  apiUrl:  'https://infiact-api.sourcebuddy.in',

  ///trial

  // apiUrl: 'https://trial-api.sourcebuddy.in',


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
